import { useEffect, useState } from 'react';
import Intercom, { onUnreadCountChange } from '@intercom/messenger-js-sdk';

import { api } from '../../api';

export const useLiveChat = () => {
  const [unreadMessages, setUnreadMessages] = useState(0);

  useEffect(() => {
    api.get('/externals/livechat/visitors/identify').then(({ data }) => {
      Intercom({
        app_id: 'dk1y0fgn',
        intercom_user_jwt: data.token,
        custom_launcher_selector: '#chat-toggle',

      });

      onUnreadCountChange((unreadCount: number) => {
        setUnreadMessages(unreadCount);
      });
    });
  }, []);

  return { unreadMessages };
};
